import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import type { RewardedVideoOptionKeys, RewardedVideoPayload, VideoStatePayload } from '@openx/types/targeting/video.ts';
import { type JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getOptionKeys, getRewardedVideoOptions } from '../../utils/utils.ts';

type Props = {
  placeholder: string;
  onChange: (typeParams: RewardedVideoPayload | VideoStatePayload | null) => void;
  value: RewardedVideoOptionKeys | null;
  label: string;
};

export const RewardedVideoDropdown = ({ placeholder, onChange, value, label }: Props): JSX.Element => {
  const { t } = useTranslation();

  const videoOptions = useMemo(() => getRewardedVideoOptions(t), [t]);

  const handleChange = useCallback(
    (_e, value) => (value ? onChange({ op: value, val: 'true' }) : onChange(null)),
    [onChange]
  );

  return (
    <AutoComplete<RewardedVideoOptionKeys, false, false, false>
      textFieldProps={{ placeholder, label }}
      options={getOptionKeys(videoOptions)}
      fullWidth
      renderOptions={{
        dataTest: 'type-option',
      }}
      getOptionLabel={option => videoOptions[option].name}
      onChange={handleChange}
      value={value}
      textFieldReadOnly
      data-test="video-input"
    />
  );
};
